// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { useEffect } from 'react';
import { PlasmicReturnModal } from "./plasmic/cps/PlasmicReturnModal";

import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { setPopUps, showReturnModal, toggleThinkToolPopup, toggleUserDashboard } from "../redux/reducers/view";
import { addComponentStatusRequest, ReturnStatus } from "../redux/reducers/addComponentStatus";
import { STATUSES } from "../constants";
import { getUserProgramsFullRequest, resetelectedContent, selectAssessment, selectItem, selectUserContent, selectUserModule, selectUserPrograms, selectUserVersion } from "../redux/reducers/userProgramsFull";
import { contentListRequest } from "../redux/reducers/contentList";
import { getFilteredComponents, getModulesForProgram, selectedContent, selectedModule, selectedModuleId, selectedProgramId } from "../redux/selectors";
import { dropdownsRequest } from "../redux/reducers/dropdowns";
import { modulesListRequest } from "../redux/reducers/modulesList";
import { learnerVersionsRequest } from "../redux/reducers/savedVersions";

function ReturnModal_(props, ref) {

 

  useEffect(() => {
if(props.view.returnItem && props.loginReducer.user){
console.log('pepe 7', props.loginReducer.user)
  
  
}
props.selectItem(props.view.returnItem)
    return () => {
      // cleanup code (optional)
    };
  }, [props.view.returnItem,props.loginReducer]);

 const handleYes = (event) => {
  props.selectUserPrograms(props.view.returnItem.program_id);
  props.selectUserModule(props.view.returnItem.module_id);
  props.selectUserContent(props.view.returnItem.contentId);
  props.selectAssessment(props.view.returnItem.survey_id);
  props.selectUserModule(props.view.returnItem.module_id);
  //props.resetelectedContent();
  if (props.view.isUserDashboardOpened) {
    props.toggleUserDashboard(false);
  }
  
  
   
    console.log('pepepx', props.view.returnItem.type)
   if(props.view.returnItem.type=='Journal'){
    props.selectUserVersion(null)
   
    props.history.push(`/tools/${props.view.returnItem.program_id}/${props.view.returnItem.contentId}`);
    
   }else if(props.view.returnItem.type=='ThinkTool'){
    // props.selectUserVersion(null)
    
    // props.history.push(`/tools/${props.view.returnItem.program_id}/${props.view.returnItem.contentId}`);
    props.learnerVersionsRequest()
    props.toggleThinkToolPopup(true)
   }else{
    props.history.push('/content/'+props.view.returnItem.program_id+'/'+props.view.returnItem.module_id);
    var tmp = props.view.popups;
    tmp.push(props.view.returnItem);
    props.setPopups(tmp);

   }
   props.getContentList()
  props.getUserProgramsFullRequest()
  props.dropdownsRequest()
  props.getModulesForProgram()
  props.selectUserModule(props.view.returnItem.module_id);
  
  }

  return  <div>
{props.view.showReturnModal && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:100000}}>
  <PlasmicReturnModal root={{ ref }} {...props} 
   btnYes={{
    onClick:(e)=>{
      handleYes(e)
      props.showReturnModal(false)

    }
  }}
  txtTitle = {props.view.returnItem.name}
  btnNo={{
    onClick:(e)=>{
   
      props.showReturnModal(false)
    }
  }}
 
  btnClose={{
    onClick:(e)=>{
      props.showReturnModal(false)
    }
  }}

/>
</div>}
  </div>
}


const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  selectedProgramId: selectedProgramId(state),
  selectedModuleId:selectedModuleId(state),
  selectedModule: selectedModule(state),
  filteredContent: getFilteredComponents(state),
  selectedContentItem: selectedContent(state),
});
const mapDispatchToProps = dispatch => ({
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  selectUserVersion: contentId => dispatch(selectUserVersion(contentId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  showReturnModal: bool => dispatch(showReturnModal(bool)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  resetelectedContent: () => dispatch(resetelectedContent()),
  getContentList: () => dispatch(contentListRequest()),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  getModulesForProgram: () => dispatch(modulesListRequest()),
  setPopups: value => dispatch(setPopUps(value)),
  selectUserPrograms: moduleId => dispatch(selectUserPrograms(moduleId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectItem: surveyId => dispatch(selectItem(surveyId)),
});

const ReturnModal = React.forwardRef(ReturnModal_);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter
)(ReturnModal);



